export const WOMA_API_GATEWAY_NAME: string | undefined = process.env.WOMA_API_NAME
export const WOMA_END_POINT: string | undefined = process.env.WOMA_ENDPOINT
export const REGION: string | undefined = process.env.WOMA_AWS_REGION
export const userPoolId: string | undefined = process.env.USER_POOL_ID
export const userPoolWebClientId: string | undefined = process.env.USER_POOL_WEB_CLIENT_ID
